import { ModelVersion } from './researchAssistantSlice';

export const MODEL_VERSION_OPTIONS = [
  { displayValue: 'V1_Llamaindex', value: ModelVersion.V1_Llamaindex },
];

export enum COHORT_ACTIONS {
  SAVE = 'save',
  PROCESS = 'process',
  REVERT = 'revert',
}
